module.exports = __webpack_public_path__ + "img/body-model-arm-right.4240afc2.svg";